import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import SectionHeading from "@/components/common/SectionHeading";
import { INDUSTRIES } from "@/lib/data";

export default function IndustriesSection() {
  return (
    <section className="py-24 sm:py-32 relative" data-testid="industries-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHeading
          eyebrow="Industries We Serve"
          title="Deep expertise across eight US tech practices."
          sub="Software, Data, AI, Cloud, Cybersecurity, DevOps, Business Analysis and QA Automation — placed by domain-specialist recruiters, not generalists."
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6 mt-16">
          {INDUSTRIES.map((ind, i) => (
            <motion.div
              key={ind.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="group relative rounded-3xl p-7 glass overflow-hidden glow-hover"
              data-testid={`industry-card-${i}`}
            >
              <div className="flex items-start justify-between mb-6">
                <div className="w-12 h-12 rounded-2xl flex items-center justify-center"
                  style={{ background: "linear-gradient(135deg, #1E3A8A, #10B981)" }}>
                  <ind.icon className="w-5 h-5 text-white" strokeWidth={2} />
                </div>
                <span className="font-inter text-[10px] uppercase tracking-[0.18em] text-[#10B981] px-2.5 py-1 rounded-full border border-[#10B981]/30 bg-[#10B981]/5">
                  {ind.roles}
                </span>
              </div>
              <p className="font-poppins text-white text-xl font-semibold mb-2">{ind.name}</p>
              <p className="font-inter text-sm text-white/55 mb-6">{ind.desc}</p>
              <Link
                to="/industries"
                className="inline-flex items-center gap-1.5 font-inter text-[13px] text-white/80 group-hover:text-[#10B981] transition-colors"
              >
                Explore practice <ArrowRight className="w-3.5 h-3.5" />
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
